"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tourDataViewRouteModule = _interopRequireDefault(require("./tour-data-view-route.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Tooltip = function Tooltip(_ref) {
  var _document$fullscreenE;

  var children = _ref.children,
      top = _ref.top,
      left = _ref.left;
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    role: "tooltip",
    className: _tourDataViewRouteModule["default"].tooltip,
    style: {
      left: left,
      top: top
    }
  }, children), (_document$fullscreenE = document.fullscreenElement) !== null && _document$fullscreenE !== void 0 ? _document$fullscreenE : document.body);
};

Tooltip.propTypes = {
  top: _propTypes["default"].number,
  left: _propTypes["default"].number,
  children: _propTypes["default"].node
};
Tooltip.defaultProps = {
  top: 0,
  left: 0,
  children: null
};
var _default = Tooltip;
exports["default"] = _default;